enum ReferenceNumberPrefixes {
  ContentLicense = 'CONTENTLICENCE',
  Instagram = 'INSTAGRAM',
}

export { ReferenceNumberPrefixes }
